/**
 * @file
 * Collapsible facets for search page sidebar.
 *
 * Enhances facets with:
 * - Count badges extracted from labels
 * - Hide empty facets
 *
 * Note: Chevron rotation is handled purely via CSS using aria-expanded attribute
 */

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.searchFacets = {
    attach: function (context) {
      // Find all fieldsets in the sidebar
      const facetFieldsets = once('search-facets', '.block--eitr-hd-search-dataset-page-facets fieldset.facet-fieldset', context);

      facetFieldsets.forEach(function (fieldset) {
        // Hide empty facets
        const checkboxes = fieldset.querySelectorAll('.form-checkboxes .form-item');
        if (checkboxes.length === 0) {
          fieldset.style.display = 'none';
          return;
        }

        // Enhance facet labels by extracting counts into their own badge
        const labels = fieldset.querySelectorAll('.form-check-label');

        labels.forEach(function (label) {
          // Skip if we've already processed this label
          if (label.dataset.facetEnhanced === 'true') {
            return;
          }

          const text = label.textContent.trim();
          const match = text.match(/^(.*?)(?:\s*\((\d+)\))$/);

          if (!match) {
            return;
          }

          const [, optionText, count] = match;
          const textSpan = document.createElement('span');
          textSpan.className = 'facet-item__label';
          textSpan.textContent = optionText.trim();

          const countSpan = document.createElement('span');
          countSpan.className = 'facet-count';
          countSpan.textContent = count;

          // Clear existing text and append new structure
          label.textContent = '';
          label.appendChild(textSpan);
          label.appendChild(countSpan);
          label.dataset.facetEnhanced = 'true';
        });
      });

    }
  };

})(Drupal, once);
